var _path, _path2, _path3, _path4, _path5, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPercentIconGreenGradient(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M32.0339 0H9.9661C4.46198 0 0 4.46198 0 9.9661V32.0339C0 37.538 4.46198 42 9.9661 42H32.0339C37.538 42 42 37.538 42 32.0339V9.9661C42 4.46198 37.538 0 32.0339 0Z",
    fill: "url(#paint0_linear_6_87)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5703 24.2704L24.1103 17.7305",
    stroke: "#12131A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.98 19.37C18.6593 19.37 19.21 18.8193 19.21 18.14C19.21 17.4607 18.6593 16.91 17.98 16.91C17.3007 16.91 16.75 17.4607 16.75 18.14C16.75 18.8193 17.3007 19.37 17.98 19.37Z",
    stroke: "#12131A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.52 25.09C25.1993 25.09 25.75 24.5393 25.75 23.86C25.75 23.1807 25.1993 22.63 24.52 22.63C23.8407 22.63 23.29 23.1807 23.29 23.86C23.29 24.5393 23.8407 25.09 24.52 25.09Z",
    stroke: "#12131A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21 31C26.5228 31 31 26.5228 31 21C31 15.4772 26.5228 11 21 11C15.4772 11 11 15.4772 11 21C11 26.5228 15.4772 31 21 31Z",
    stroke: "#12131A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6_87",
    x1: 21,
    y1: 0,
    x2: 21,
    y2: 42,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#90DF7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#90DF7D",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPercentIconGreenGradient);
export default __webpack_public_path__ + "static/media/percent-icon-green-gradient.b143362dc5f4f4593dca21ff681df8f8.svg";
export { ForwardRef as ReactComponent };